<template>
  <div class="m-4 px-3">
    <div class="data-container">
      <div class="breadcrumbs d-flex align-items-center">
        <span
          :class="{ 'text-primary': !selected_option }"
          @click="!selected_option ? null : selected_option = null"
          :style="{ cursor: !selected_option ? null : 'pointer' }">
          Marketplace
        </span>
        <span v-if="selected_option" class="px-3 d-inline-flex align-items-center"><img src="@/assets/images/caret-right.svg" alt="Caret Right"></span>
        <span class="text-primary text-capitalize">{{ selected_option }}</span>
      </div>
      <b-row v-if="!selected_option" class="options-container mt-5">
        <b-col
          lg="3"
          md="6"
          v-for="(option, index) in marketplace"
          :key="`market_place_option_${index}`"
          class="single-option-container mb-3 d-flex"
          @click="loading ? null : goTo(option.name)"
          :style="{
            cursor: loading ? 'not-allowed' : null
          }">
          <div class="bg-white rounded p-4 flex-fill">
            <div class="img-container mb-2">
              <img :src="option.img" :alt="option.name" class="img-fluid">
            </div>
            <div class="option-details">
              <p class="mb-0"><b>{{ option.name }}</b></p>
              <small class="text-muted d-inline-flex mb-4">{{ `Powered by ${option.powered}` }}</small>
              <p class="mb-0">{{ option.details }}</p>
            </div>
          </div>
        </b-col>
      </b-row>
      <div v-else-if="selected_option === 'gamification'">
        <MarketplaceGamification />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MarketplaceGamification from "./Gamification";
import notification from "@/services/notification";

export default {
  name: "PluginsMarketplace",
  components: {
    MarketplaceGamification
  },
  data() {
    return {
      marketplace: [
        // {
        //   name: "Gamification",
        //   powered: "Perx",
        //   details: "Create experiences for your customers to enjoy your brand with fun surprise-and-delight mechanisms like ‘Spin the Wheel’, ‘Scratch Card’, ‘Shake the Tree’, and more.",
        //   img: require("@/assets/images/marketplace/perx_logo.svg")
        // },
        {
          name: "Advanced Analytics",
          powered: "Amazon Quicksight",
          details: "Gain deeper insights from your customers and their transactions using easy to read and interactive dashboards.",
          img: require("@/assets/images/marketplace/quicksight_logo.svg")
        },
        // {
        //   name: "Advanced Engagements",
        //   powered: "InforBip",
        //   details: "Elevate customer engagement with dynamic automations added to your channel mix. Try Viber, WhatsApp, and more.",
        //   img: require("@/assets/images/marketplace/infobip_logo.png")
        // },
        {
          name: "Payment Processing",
          powered: "PayMongo",
          details: "Activate more ways to pay, monitor sales, and issue refunds easily.",
          img: require("@/assets/images/marketplace/paymongo_logo.png")
        }
      ],
      selected_option: null
    }
  },
  computed: {
    ...mapGetters({
      loading: "marketplace/loading",
      user: "auth/user",
      quicksight_url: "marketplace/quicksight_url"
    })
  },
  created() {
    this.getQuicksightURL(this.user.merchant_uuid);
  },
  methods: {
    ...mapActions({
      getQuicksightURL: "marketplace/getQuicksightURL"
    }),
    goTo(name) {
      switch(name) {
        case "Gamification":
          this.selected_option = name.toLowerCase();
          break;
        case "Advanced Analytics":
          if (this.quicksight_url)
            window.open(this.quicksight_url, "_blank");
          else
            notification.warning("Your account has not been setup yet for Quicksight.");
          break;
        case "Payment Processing":
          window.open("https://dashboard.paymongo.com/login", "_blank");
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.single-option-container {
  // max-width: 254px;
  // width: 100%;
  cursor: pointer;
  .img-container {
    min-height: 53px;
  }
}
</style>
